import { action, observable, runInAction } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _MvaStoreRS {
  obs = observable({
    mvas: [] as any[],
    currentPage: 1 as number,
    length_mvas: 0 as number,
    filter_vigencia: true as boolean,
    selectedTab: "entrada" as string
  })

  @action
  async handlePageFilter(page: number, filter: string) {
    let data = {
      page: page,
      limit: 20,
      filter: filter.replace(/\./g, ""),
      vigencia: this.obs.filter_vigencia,
      entrada: this.obs.selectedTab == "entrada" ? true : false
    }

    let resp = await api.post("/api/mva/rs/index", data);

    this.obs.mvas = [];
    this.obs.length_mvas = 0;

    if (resp.data.itens.length > 0) {
      this.obs.mvas = resp.data.itens
      this.obs.length_mvas = resp.data.count
    }

  }

  async doSaveCreateMva(mva) {
    try {
      let resp = await api_adm.post("/api/admin/mva/rs/create", mva);
      if (resp.data.ok) {
        toast.success('MVA Criado!', {});

      } else {
        toast.error(`Não foi possível criar MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível criar MVA: ${ex}`, {});
    }
  }

  async handleDeleteMva(id) {
    try {
      let resp = await api_adm.delete(`/api/admin/mva/rs/${id}`);

      if (resp.data.ok) {
        toast.success('MVA excluído!', {});
        return true

      } else {
        toast.error(`Não foi possível exluir MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível excluir MVA ${ex}`, {});
    }

    return false

  }

  async doSaveEditMva(mva) {
    try {
      let resp = await api_adm.post('/api/admin/mva/rs/update', mva);

      if (resp.data.ok) {
        toast.success('MVA Editado!', {});

      } else {
        toast.error(`Não foi possível salvar MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível salvar MVA: ${ex}`, {});
    }
  }

  async doSaveDuplicaMva(mva) {

    try {

      let resp = await api_adm.post('/api/admin/mva/rs/create', mva);

      if (resp.data.ok) {

        toast.success('MVA Duplicado', {});
        return true

      } else {

        toast.error(`Não foi possível duplicar o MVA: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Não foi possível duplicar o MVA: ${ex}`, {});

    }

    return false

  }

  async handleAplicaFrete(mva_id, checked) {

    let data = {
      id: mva_id,
      aplica_frete: checked
    }

    let resp = await api_adm.post('/api/admin/mva/rs/frete', data);

    if (resp.data.ok) {
      toast.success('Frete Atualizado!', {});
      return true

    } else {
      toast.error(`Não foi possível atualizar Frete: ${resp.data.msg}`, {});
    }

    return false

  }
}

export const MvaStoreRS = new _MvaStoreRS();
